import { useContext } from "react";
import { TriggeredHook } from "sonobello.utilities.react";

import AppContext from "../../../../AppContext";
import AppointmentNoteContentBuilder, {
  AppointmentNoteTagProps
} from "../../../Notes/Compositions/AppointmentNoteContentBuilder";
import IReservation from "../../../Types/IReservation";
import { IConfirmedAppointmentResponse } from "../Hooks/UseConfirmOpsAppointmentWithDistance";
import useConfirmOpsAppointmentWithDistance from "../Hooks/UseConfirmOpsAppointmentWithDistance";
import useCreateLeadResult from "../Hooks/UseCreateLeadResult";

/** A composed hook used to confirm an appointment. */
const AppContextUseConfirmAppointment: TriggeredHook<IConfirmedAppointmentResponse, IReservation, boolean> = () => {
  const { defaultCenter, patient, leadIdCState, medicalConclusions, reservation } = useContext(AppContext);
  return useConfirmOpsAppointmentWithDistance({
    useCreateLeadResult,
    noteProps: {
      patient: patient,
      medicalConclusions,
      reservation: reservation!,
      center: defaultCenter
    } as AppointmentNoteTagProps,
    noteContentBuilder: AppointmentNoteContentBuilder,
    patient: patient,
    leadId: leadIdCState
  });
};

export default AppContextUseConfirmAppointment;
